/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Lot_Trace_Step_ProductInputs */

const vi_order_lot_trace_step_product = /** @type {(inputs: Order_Lot_Trace_Step_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô thành phẩm`)
};

/**

* @param {Order_Lot_Trace_Step_ProductInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_lot_trace_step_product = /** @type {((inputs?: Order_Lot_Trace_Step_ProductInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Lot_Trace_Step_ProductInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_lot_trace_step_product(inputs)
});